import { PencilIcon, ArrowDownOnSquareIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import MainButton from '@/components/ui/custom/buttons/MainButton';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';

type Props = {
  onEdit(): void;
  editing?: boolean;
};

export default function EditResourceButton(props: Props) {
  const [t] = useTranslation('translation', {
    keyPrefix: 'common',
  });

  const { editing, onEdit } = props;

  const editIcon = editing ? <ArrowDownOnSquareIcon /> : <PencilIcon />;

  return (
    <Tooltip text={editing ? t('finish') : t('edit')}>
      <MainButton
        dataTestId="editResourceButton"
        className="text-primary flex-row-reverse gap-1 font-500 text-[0.875rem]"
        color="custom"
        onClick={onEdit}
        text={editing ? t('finish').toLowerCase() : ''}
        icon={editIcon}
      />
    </Tooltip>
  );
}
